// Emoji cursor daily switcher
(function() {
  'use strict';
  
  // Function to get today's cursor type based on date
  function getTodaysCursor() {
    const today = new Date();
    const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 86400000);
    
    // Alternate between dog and cat based on day of year
    return dayOfYear % 2 === 0 ? 'emoji-cursor-dog' : 'emoji-cursor-cat';
  }
  
  // Function to apply cursor class to body
  function applyCursor() {
    const cursorClass = getTodaysCursor();
    
    // Remove any existing cursor classes
    document.body.classList.remove('emoji-cursor-dog', 'emoji-cursor-cat');
    
    // Add today's cursor class
    document.body.classList.add(cursorClass);
    
    // Store in localStorage for consistency during the day
    localStorage.setItem('alphapets-cursor-date', new Date().toDateString());
    localStorage.setItem('alphapets-cursor-class', cursorClass);
  }
  
  // Check if we need to update the cursor
  function checkAndApplyCursor() {
    const storedDate = localStorage.getItem('alphapets-cursor-date');
    const today = new Date().toDateString();
    
    if (storedDate !== today) {
      // New day, apply new cursor
      applyCursor();
    } else {
      // Same day, use stored cursor
      const storedClass = localStorage.getItem('alphapets-cursor-class');
      if (storedClass) {
        document.body.classList.remove('emoji-cursor-dog', 'emoji-cursor-cat');
        document.body.classList.add(storedClass);
      } else {
        applyCursor();
      }
    }
  }
  
  // Apply cursor on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndApplyCursor);
  } else {
    checkAndApplyCursor();
  }
  
  // Optional: Add toggle functionality for testing
  window.toggleEmojiCursor = function() {
    if (document.body.classList.contains('emoji-cursor-dog')) {
      document.body.classList.remove('emoji-cursor-dog');
      document.body.classList.add('emoji-cursor-cat');
    } else {
      document.body.classList.remove('emoji-cursor-cat');
      document.body.classList.add('emoji-cursor-dog');
    }
  };
})();